import { render, staticRenderFns } from "./alibabaProductList.vue?vue&type=template&id=fc1379b2&scoped=true&"
import script from "./alibabaProductList.vue?vue&type=script&lang=js&"
export * from "./alibabaProductList.vue?vue&type=script&lang=js&"
import style0 from "./alibabaProductList.vue?vue&type=style&index=0&id=fc1379b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1379b2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/alibaba/product/alibabaProductList.vue
// module id = null
// module chunks = 